import type React from 'react';
import type { AudiMarketContextServiceV2 } from '@oneaudi/market-context-service';

export interface LayerContentHTMLProps {
  audiMarketContextService?: AudiMarketContextServiceV2;
  url?: string;
  withFefa?: boolean;

  fromLayer?: boolean;
  fefaStyleConfig?: IFefaStyleProps;
  enableDeepLinking?: boolean;
}

interface IFefaStyleProps {
  omitBottomSpacing?: string;
  omitSideSpacing?: string;
  uiTheme?: string;
}

export const MARKER_XHR = 'headless';
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    SETUPS: any;
  }
}

export const LayerContentHTML: React.FC<LayerContentHTMLProps> = () => {
  return null;
};
